import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import visibleCheckItem from 'webapp/modifiers/visible-check-item';
import BarLoaderOverlayComponent from 'webapp/components/bar-loader-overlay';
import BillingLimitationWarningComponent from 'webapp/components/billing/limitation-warning';
import BoardImagePreviewComponent from 'webapp/components/board/image-preview';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import EditableModelPropertyComponent from 'webapp/components/editable-model-property';
import SubmitButtonComponent from 'webapp/components/submit-button';
import type { Args as TemplatesTransferedNotificationBaseArgs } from 'webapp/components/templates/transfered-notification/base';
import TemplatesTransferedNotificationBaseComponent from 'webapp/components/templates/transfered-notification/base';
import ToolTipComponent from 'webapp/components/tool-tip';
import UsedSourcesListComponent from 'webapp/components/used-sources-list';

export default class TemplatesTransferedNotificationPublicGridItemComponent extends TemplatesTransferedNotificationBaseComponent<TemplatesTransferedNotificationBaseArgs> {
	@tracked isVisibleOnScreen = true;

	@action
	visibleChanged(isVisible: boolean): void {
		this.isVisibleOnScreen = isVisible;
	}
	<template>
		<li
			class="card card--preview card--public-template-notification flex-item
				{{this.classNames}}"
		>

			<BoardImagePreviewComponent
				@image={{this.templateModel.image}}
				@isVisibleOnScreen={{this.isVisibleOnScreen}}
			/>

			{{#if this.isVisibleOnScreen}}

				<div class="overlay">

					<div class="overlay-bg"></div>

					<div class="wrap">
						<div class="actions">
							<div class="actions__top">
								<SubmitButtonComponent
									@text="Preview"
									@extraClass="previewbutton"
									@onTrigger={{this.previewTemplate}}
									@noDelay={{true}}
									@theme="blue-outlined"
								/>
							</div>
							<div class="actions__bottom">
								<a
									role="button"
									{{on "click" (fn this.handleTransferedObject false)}}
								>
									<CommonUiIconComponent @name="Trash" @size="sm" />
									<ToolTipComponent @text="Remove template" />
								</a>
							</div>
						</div>
					</div>

				</div>

				<div class="info">

					<div class="anti-stretch">
						<EditableModelPropertyComponent @model={{@model}} @canEdit={{false}} />
					</div>

					{{#if this.templateModel}}
						<UsedSourcesListComponent
							@sources={{this.templateModel.sourcesUsedList}}
							@maxShownSourcesCount={{10}}
							@size="sm"
						/>
					{{/if}}

				</div>

				<div class="bottom">
					<div class="bottom__stretch">
						<a
							role="button"
							class="button theme-green"
							{{on "click" (fn this.handleTransferedObject true)}}
						>
							<CommonUiIconComponent @name="Connect" @size="sm" />Connect
							{{#if this.showLimitationWarning}}
								<BillingLimitationWarningComponent />
							{{/if}}
						</a>
					</div>
				</div>

				<BarLoaderOverlayComponent @isActive={{this.isRequestPending}} />

			{{else}}
				<div class="info" {{visibleCheckItem this.visibleChanged false}}>
					<div class="anti-stretch">&nbsp;</div>
				</div>
			{{/if}}

		</li>
	</template>
}
